import React from 'react';

function UserTemplateShell({ title, subtitle, children }) {
  return (
    <div className="tw min-h-screen w-full bg-zinc-100 text-zinc-900">
      <div className="mx-auto flex min-h-screen w-full max-w-[1200px] flex-col border-x border-zinc-200 bg-white">
        <header className="flex h-14 items-center justify-between border-b border-zinc-200 px-4">
          <div>
            <div className="text-sm font-semibold">{title}</div>
            {subtitle ? <div className="text-xs text-zinc-500">{subtitle}</div> : null}
          </div>
          <a href="/" className="rounded-lg border border-zinc-300 px-3 py-1.5 text-xs font-medium hover:bg-zinc-50">
            Kembali ke Chat
          </a>
        </header>

        <main className="flex-1 bg-zinc-50 p-4">{children}</main>
      </div>
    </div>
  );
}

export default UserTemplateShell;
